import Vue from "vue";
import axios from "axios";
import moment from "moment";
import store from "@/store/store";
import { mapState, mapGetters } from "vuex";
import { showToast } from "@/utilities/Helpers";

const interceptorMessages = (error, is400 = true) => {};

Vue.use({
  install(Vue) {
    /* CONFIGURAÇÃO IDENTITYSERVER */
    Vue.prototype.$httpIdentityServer = axios.create({
      baseURL: process.env.VUE_APP_API_ACESSO,
    });
    const session = store.getters["login/getState"];

    Vue.prototype.$httpIdentityServer.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        interceptorMessages(error, false);

        return Promise.reject(error);
      }
    );

    /* CONFIGURAÇÃO IDENTITY SERVER API */
    Vue.prototype.$httpIdentityServerApi = axios.create({
      baseURL: process.env.VUE_APP_API_ACESSO_ADMIN,
    });

    Vue.prototype.$httpIdentityServerApi.interceptors.request.use(
      (config) => {
        const user =
          Vue.prototype.getRoot !== undefined
            ? Vue.prototype.getRoot.user
            : localStorage.getItem("userProfile");
        if (user) {
          const authToken = user.access_token;
          if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
          }
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    Vue.prototype.$httpIdentityServerApi.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        interceptorMessages(error, true);

        return Promise.reject(error);
      }
    );

    Vue.prototype.$httpPbs = axios.create({
      baseURL: process.env.VUE_APP_API_PBS,
    });

    Vue.prototype.$httpPortal = axios.create({
      baseURL: process.env.VUE_APP_API_PORTAL_CORRETOR,
    });

    Vue.prototype.$httpCotador = axios.create({
      baseURL: process.env.VUE_APP_API_COTADOR,
    });

    Vue.prototype.$httpCotaMais = axios.create({
      baseURL: process.env.VUE_APP_API_COTA_MAIS,
    });

    Vue.prototype.$httpSinistro = axios.create({
      baseURL: process.env.VUE_APP_SSO_SALES_FORCE,
    })

    Vue.prototype.$httpPbs.interceptors.request.use(
      (config) => {
        const user =
          Vue.prototype.getRoot !== undefined
            ? Vue.prototype.getRoot.user
            : localStorage.getItem("userProfile");
        if (user) {
          const authToken = user.access_token;
          if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
          }
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    Vue.prototype.$httpPortal.interceptors.request.use(
      (config) => {
        const user =
          Vue.prototype.getRoot !== undefined
            ? Vue.prototype.getRoot.user
            : localStorage.getItem("userProfile");
        if (user) {
          const authToken = user.access_token;
          if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
          }
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    Vue.prototype.$httpCotador.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const {
          config,
          response: { status },
        } = error;

        if (status === 500) {
          Vue.prototype.$toast.error("Ocorreu um erro inesperado!", "erro");
        }

        return Promise.reject(error);
      }
    );
  },
});
